function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Loading from '../../components/loading/Loading';
import Timeline from '../../components/timeline/Timeline';
import { ACTIVITY_TYPES } from '../../constants/activity';
import { PRODUCT_TYPE, SMART_SELECTION_DELIVERY_METHOD } from '../../constants/product';
import { listProjectActivities } from '../../redux/actions';
import { generateDefaultActivity } from '../../utilities/activity';
import { isStaff } from '../../utilities/user';
import JobActivity from './JobActivity';
var JobTimeline = function() {
    var dispatch = useDispatch();
    // TODO: confusing, projectId vs currentProject?
    var _useSelector = useSelector(function(state) {
        return {
            projects: state.activity.projects,
            isStaffActivityListVisible: state.activity.isStaffActivityListVisible,
            currentUser: state.profileReducer.userProfile,
            currentProject: state.project.currentProject
        };
    }), projects = _useSelector.projects, currentUser = _useSelector.currentUser, currentProject = _useSelector.currentProject, isStaffActivityListVisible = _useSelector.isStaffActivityListVisible;
    var projectId = useParams().projectId;
    var isLoading = useMemo(function() {
        var _projects_projectId_ui, _projects_projectId;
        return (_projects_projectId = projects[projectId]) === null || _projects_projectId === void 0 ? void 0 : (_projects_projectId_ui = _projects_projectId.ui) === null || _projects_projectId_ui === void 0 ? void 0 : _projects_projectId_ui.isLoading;
    }, [
        projectId,
        projects
    ]);
    var fetchProjectActivities = useCallback(function() {
        if (projectId) {
            dispatch(listProjectActivities(projectId));
        }
    }, [
        dispatch,
        projectId
    ]);
    useEffect(function() {
        fetchProjectActivities();
    }, [
        fetchProjectActivities
    ]);
    /**
   * Duplicate an order that has metadata && metadata.action === quote
   * Bcoz, RFQ Activity is not created and save, only one activity type="order" and title "Order received".
   */ var projectActivities = useMemo(function() {
        var _projects_projectId;
        if ((_projects_projectId = projects[projectId]) === null || _projects_projectId === void 0 ? void 0 : _projects_projectId.activities) {
            var _projects_projectId1;
            var activities = _to_consumable_array((_projects_projectId1 = projects[projectId]) === null || _projects_projectId1 === void 0 ? void 0 : _projects_projectId1.activities);
            if (currentProject.jobs && activities) {
                var rfqActivities = activities.filter(function(param) {
                    var type = param.type, metadata = param.metadata;
                    return type === ACTIVITY_TYPES.order && !isEmpty(metadata) && metadata.action === 'quote';
                }).map(function(activity) {
                    var _job_quote;
                    var job = currentProject.jobs.find(function(param) {
                        var id = param.id;
                        return id === activity.job_id;
                    });
                    if (!job) {
                        return [];
                    }
                    var rfqCharges = (_job_quote = job.quote) === null || _job_quote === void 0 ? void 0 : _job_quote.charges.filter(function(charge) {
                        return charge.type === 'data' && [
                            PRODUCT_TYPE.UNKNOWN,
                            SMART_SELECTION_DELIVERY_METHOD.MANUAL
                        ].includes(charge.details.delivery_method);
                    });
                    return _object_spread_props(_object_spread({}, activity), {
                        rfqCharges: rfqCharges
                    });
                }).filter(function(param) {
                    var rfqCharges = param.rfqCharges;
                    return rfqCharges && rfqCharges.length > 0;
                });
                if (rfqActivities.length === 0) {
                    return activities;
                }
                return _to_consumable_array(activities).concat(_to_consumable_array(rfqActivities));
            }
        }
        return [];
    }, [
        currentProject.jobs,
        projectId,
        projects
    ]);
    var rawActivities = projectActivities === null || projectActivities === void 0 ? void 0 : projectActivities.sort(function(a, b) {
        var dateA = new Date(a.created_at);
        var dateB = new Date(b.created_at);
        return dateB - dateA;
    });
    var activities = isEmpty(rawActivities) ? [
        generateDefaultActivity()
    ] : filter(rawActivities, function(activity) {
        return !isStaffActivityListVisible ? !isStaff(activity === null || activity === void 0 ? void 0 : activity.visibility) : true;
    });
    // TODO: refactor job to project timeline and activity
    return /*#__PURE__*/ React.createElement(Timeline, {
        className: "JobTimeline"
    }, isLoading ? /*#__PURE__*/ React.createElement(Loading, null) : activities && activities.map(function(activity, i) {
        return /*#__PURE__*/ React.createElement(JobActivity, {
            key: i,
            currentProject: currentProject,
            jobActivity: activity,
            currentUser: currentUser
        });
    }));
};
export default JobTimeline;
